import { AdminCard, AdminHeader, Field } from "./AdminShell";

export default function Banners() {
  return (
    <div>
      <AdminHeader title="Banners" description="Create lightweight promotional banners with image URLs. R2 upload can be enabled later, but this page works with external image links today." />
      <AdminCard title="Banner Editor">
        <div className="grid gap-4 lg:grid-cols-2">
          <Field label="Title"><input className="input" placeholder="Weekend Essentials" /></Field>
          <Field label="Position"><select className="input"><option>Homepage</option><option>Product list</option><option>Checkout</option></select></Field>
          <Field label="Image URL"><input className="input" placeholder="https://..." /></Field>
          <Field label="Button Link"><input className="input" placeholder="/en/products" /></Field>
          <Field label="Subtitle"><textarea className="input min-h-24 rounded-[24px]" /></Field>
          <div className="rounded-[24px] bg-[#FDF9F1] p-4">
            <img className="aspect-[16/9] w-full rounded-[20px] object-cover" src="/placeholder.webp" />
          </div>
        </div>
      </AdminCard>
    </div>
  );
}
